import { render, staticRenderFns } from "./c-widget-tab@.vue?vue&type=template&id=31c1a3cc&scoped=true&"
import script from "./c-widget-tab@.vue?vue&type=script&lang=ts&"
export * from "./c-widget-tab@.vue?vue&type=script&lang=ts&"
import style0 from "./c-widget-tab@.vue?vue&type=style&index=0&id=31c1a3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1a3cc",
  null
  
)

export default component.exports